import { Grid, MenuItem } from '@mui/material';
import { FC, SetStateAction, Dispatch } from 'react';
import { FiltersLayout, FiltersButtons, SearchField, SMBSelect } from '../../../components';
import { IDropdownResponse, IManagePlaceOrderReportsTo } from '../../../models';

interface IEntraInternalFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setHasAppliedFilters: Dispatch<SetStateAction<boolean>>;
  hasAppliedFilters: boolean;
  setSearchValue?: (val: string) => void;
  setSearchedValue?: (val: string) => void;
  searchValue?: string;
  handleSearch?: (val: string) => void;
  setSelectedRole?: (val: string | number) => void;
  selectedRole?: string | number;
  setSelectedReportsTo?: (val: string) => void;
  selectedReportsTo?: string | number;
  searchPlaceholder?: string;
  isLoadingRoles: boolean;
  roles: IDropdownResponse[];
  reportsTo: IManagePlaceOrderReportsTo[];
  isLoadingAvailableReportsTo: boolean;
}

export const EntraInternalFilters: FC<IEntraInternalFilters> = ({
  isLoading,
  applyFilters,
  setHasAppliedFilters,
  hasAppliedFilters,
  handleSearch,
  searchValue,
  setSearchValue,
  setSearchedValue,
  setSelectedRole,
  selectedRole,
  searchPlaceholder,
  isLoadingRoles,
  roles,
  selectedReportsTo,
  setSelectedReportsTo,
  reportsTo,
  isLoadingAvailableReportsTo
}) => {
  return (
    <FiltersLayout>
      {handleSearch && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SearchField
            isDisabled={isLoading}
            placeholder={searchPlaceholder}
            handleSearch={handleSearch}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
        </Grid>
      )}
      {setSelectedRole && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SMBSelect
            variant="outlined"
            handleClear={() => {
              setSelectedRole('');
            }}
            name={`emailType`}
            id={`emailType`}
            label="Role"
            value={selectedRole}
            disabled={isLoadingRoles}
            onChange={event => {
              setSelectedRole(event.target.value);
            }}
          >
            {roles &&
              roles.map((role, index) => {
                return (
                  <MenuItem key={`${index}`} value={role.value}>
                    {role.description}
                  </MenuItem>
                );
              })}
          </SMBSelect>
        </Grid>
      )}
      {setSelectedReportsTo && (
        <Grid item xs={12} sm={6} md={4} xl={3}>
          <SMBSelect
            handleClear={() => setSelectedReportsTo('')}
            disabled={isLoadingAvailableReportsTo}
            label="Reports to"
            name="reportsTo"
            variant="outlined"
            value={selectedReportsTo}
            onChange={event => {
              setSelectedReportsTo(event.target.value as string);
            }}
          >
            {reportsTo &&
              reportsTo.map((reportsTo, index) => {
                return (
                  <MenuItem key={`${index}`} value={reportsTo.accountName}>
                    {reportsTo.displayName}
                  </MenuItem>
                );
              })}
          </SMBSelect>
        </Grid>
      )}
      <Grid item xs={12} md={5} xl={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedRole && setSelectedRole('');
            setSelectedReportsTo && setSelectedReportsTo('');
            setSearchedValue && setSearchedValue('');
            setSearchValue && setSearchValue('');
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
